import { Button } from '@/components/ui/button';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense } from 'react';
import { SollstundenWidget } from './SollstundenWidget';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { t } from 'i18next';
import { AbsatzZiele, UmsatzZiele } from './UmsatzAbsatzWidget';
import { ZieleSkeleton } from './UmsatzAbsatzWidget/ZieleSkeleton';
import { useNavigate, useParams } from 'react-router-dom';
import { MonthParams } from '../types';
import { Skeleton } from '@/components/ui/skeleton';
import { useStandortContext } from '@/features/standortContext/StandortContext';

// eslint-disable-next-line max-lines-per-function
export function ZieleWrapper() {
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige: tagebuchAnzeige } =
    useTagebuchEinstellungen(standortId);
  const navigate = useNavigate();
  const { year, month } = useParams<MonthParams>();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-1">
        <h4 className="text-xl font-bold text-neutrals-900">
          {t('domain.controlling.umsatzplanung.ziele.header')}
        </h4>
        <Button
          size="icon"
          variant="ghost"
          onClick={() =>
            navigate(
              `/controlling/umsatzplanung/${year}/${month}/ziele/edit?jahr=${year}&monat=${month}`,
            )
          }>
          <FontAwesomeIcon className="text-primary-blue-600" icon={faEdit} />
        </Button>
      </div>
      <div className="flex justify-between items-stretch gap-4">
        <Suspense
          fallback={<ZieleSkeleton tagebuchAnzeige={tagebuchAnzeige} />}>
          {tagebuchAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' && (
            <div className="flex flex-col gap-4 grow justify-between">
              <div className="bg-white rounded-lg">
                <UmsatzZiele />
              </div>
              <div className="bg-white rounded-lg">
                <AbsatzZiele />
              </div>
            </div>
          )}
          {tagebuchAnzeige === 'UMSATZ_PRODUKTIVITAET' && (
            <div className="bg-white rounded-lg grow">
              <UmsatzZiele />
            </div>
          )}
          {tagebuchAnzeige === 'ABSATZ_PRODUKTIVITAET' && (
            <div className="bg-white rounded-lg grow">
              <AbsatzZiele />
            </div>
          )}
        </Suspense>
        <div className="w-[300px]">
          <Suspense fallback={<Skeleton className="w-full h-full" />}>
            <SollstundenWidget />
          </Suspense>
        </div>
      </div>
    </div>
  );
}
